import { Button, IconButton, Typography } from "@material-ui/core"
import { CarModelTopBanner, ImageModel } from "api"
import { Desktop, Mobile } from "common/MediaQueries"
import NextImage from "common/bit/NextImage"
import NextLink from "common/bit/NextLink"
import { isValidMediaUrl } from "common/isValidMediaUrl"
import styled from "styled-components"

const StyledTopBanner = styled.div<{ $bgColor?: string }>`
  border-bottom: 1px solid rgba(76, 96, 126, 0.2);
  background: #d0d3da;
  ${(p) => p.$bgColor && `background-color: ${p.$bgColor};`}
  height: 64px;
  position: relative;
  padding: 0;
  padding-right: 60px;
  gap: 16px;
  z-index: 2;
  margin-top: 50px;
  margin-bottom: -60px;
  ${(p) => p.theme.breakpoints.up("md")} {
    height: 80px;
    margin-top: 81px;
    margin-bottom: -80px;
    padding: 0 176px 0 32px;
  }
`
const StyledImageWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  height: 100%;
  right: 0;
  width: 160px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 60px;
  }
`
const StyledContent = styled.div`
  position: relative;

  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 9px 0;
`
const StyledTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`
const StyledTypography = styled(Typography)<{ component: string }>`
  position: relative;
  line-height: 1.2;
  ${(p) => p.theme.breakpoints.down("sm")} {
    font-size: 8px;
    line-height: 16px;
  }
  p {
    margin: 0;
  }
`
// const StyledTypographySubtitle = styled(Typography)`
//   position: relative;
//   ${(p) => p.theme.breakpoints.down("sm")} {
//     font-size: 12px;
//   }
// `
const StyledButton = styled(Button)`
  position: relative;
  background-color: #4c607e;
  border-color: #4c607e;

  ${(p) => p.theme.breakpoints.down("sm")} {
    padding-right: 5px;
  }
`

const BannerImage = ({ image }: { image: ImageModel }) => (
  <NextImage
    image={image}
    priority
    cover={false}
    objectPosition="bottom right"
  />
)

type Props = {
  data: CarModelTopBanner
}

const ModelPageTopBanner = ({ data }: Props) => {
  if (!data) return null

  const {
    imageMob,
    imageWeb,
    buttonText,
    buttonUrl,
    isActive,
    isButtonActive,
    titleMob,
    titleWeb,
    color,
  } = data

  if (!isActive) return null

  return (
    <StyledTopBanner $bgColor={color}>
      {isValidMediaUrl(imageMob?.imageUrl) && (
        <Mobile aboveTheFold>
          <StyledImageWrapper>
            <BannerImage image={imageMob} />
          </StyledImageWrapper>
        </Mobile>
      )}
      {isValidMediaUrl(imageWeb?.imageUrl) && (
        <Desktop aboveTheFold>
          <StyledImageWrapper>
            <BannerImage image={imageWeb} />
          </StyledImageWrapper>
        </Desktop>
      )}
      <StyledContent>
        <StyledTextWrapper>
          <Mobile>
            {titleMob && (
              <StyledTypography
                variant="h2"
                component="div"
                dangerouslySetInnerHTML={{ __html: titleMob }}
              />
            )}
          </Mobile>
          <Desktop>
            {titleWeb && (
              <StyledTypography
                variant="h2"
                component="div"
                dangerouslySetInnerHTML={{ __html: titleWeb }}
              />
            )}
          </Desktop>
        </StyledTextWrapper>
        {isButtonActive && (
          <>
            <Desktop>
              <NextLink href={buttonUrl} passHref>
                <StyledButton aria-label={buttonText}>
                  {buttonText}
                </StyledButton>
              </NextLink>
            </Desktop>
            <Mobile>
              <NextLink href={buttonUrl} passHref>
                <IconButton aria-label={buttonText}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      d="M11.25 4.5L6.75 9L11.25 13.5"
                      stroke="#4C607E"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </IconButton>
              </NextLink>
            </Mobile>
          </>
        )}
      </StyledContent>
    </StyledTopBanner>
  )
}

export default ModelPageTopBanner
